/**
 * The Utsaaha wordmark: the red "utsaaha" lettering with the eyes above the
 * "ha". It is cropped from apps/mobile/assets/logo_name.png and served from
 * /public at 1x and 2x, so the 1875px square source never reaches the browser.
 *
 * The artwork is red on white, so it sits on a white rounded chip. On the
 * jamun sidebar and login panel that reads as a badge rather than red lettering
 * on dark purple.
 *
 * `height` is the height of the lettering. The chip adds a few pixels of
 * padding around it, and the width follows the 10:3 artwork ratio.
 */
export const BRAND_NAME = 'Utsaaha Lifestyle';

const RATIO = 480 / 144;

export function BrandLogo({ height = 32, className = '' }: { height?: number; className?: string }) {
  const width = Math.round(height * RATIO);
  const pad = Math.max(3, Math.round(height * 0.18));
  return (
    <span
      className={`inline-flex shrink-0 select-none items-center justify-center rounded-md bg-white ring-1 ring-black/10 ${className}`}
      style={{ padding: `${pad}px ${Math.round(pad * 1.4)}px` }}
    >
      <img
        src="/logo-wordmark.png"
        srcSet="/logo-wordmark.png 1x, /logo-wordmark@2x.png 2x"
        width={width}
        height={height}
        alt={BRAND_NAME}
        draggable={false}
        className="block object-contain"
        style={{ width, height }}
      />
    </span>
  );
}
